import styled from 'styled-components';

const SearchWrapper = styled.div`
  padding: 20px 40px;
`;

const TableWrapper = styled.div`
  max-height: 400px;
  overflow: auto;
`;

const SearchSelectModalLayout = {
  SearchWrapper,
  TableWrapper
};

export default SearchSelectModalLayout;
